export default __webpack_public_path__ + "static/media/NeueHaasDisplay-Light.20907342.woff";